import {useEffect, useState} from "react";
import {getItem} from "../api/apiClient";

export const useItem = (itemUuid) => {
    const [item, setItem] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();

        getItem(itemUuid, abortController.signal)
            .then((data) => {
                setItem(data);
            })
            .catch((error) => console.log(error));

        return () => {
            abortController.abort();
        };
    }, [itemUuid]);

    return {item};
};
